import { MilkmanFreshFoodApi } from '../api/MilkmanFreshFoodApi'
import { milkmanStore } from './milkmanStore'
import _ from 'lodash'

const store = _.clone(milkmanStore)
store.api = MilkmanFreshFoodApi
store.sendAddress = true
export const milkmanFreshFoodStore = store;